export const BASE_ERROR_MESSAGE = 'Something went wrong'
export const DNS_GOOGLE_PATH = 'https://dns.google/resolve'
